/*****************
 * Filters
 ******************/

/**
 * Handle a filter link click.
 * @param {Event} event
 * @return void
 */
async function handleFilterLinkClick(event) {
    event.preventDefault();

    document.querySelector(".collectionGridItems").classList.add("loading");

    // Build url
    const url = new URL(this.href);

    url.searchParams.set("sections", "main-collection");
    url.searchParams.set("filter.v.availability", "1");

    const section = await fetch(url);

    // Delete section param from URL. It will cause an issue if the page is loaded with that parameter
    url.searchParams.delete("sections");

    // Add filters to URL
    history.replaceState(null, "", `?${url.searchParams.toString()}`);

    const sectionJson = await section.json();

    document.querySelector(".collectionGridItems").classList.remove("loading");

    const htmlParser = new DOMParser();

    const sectionDocument = htmlParser.parseFromString(sectionJson["main-collection"], "text/html");


    // Update filters
    document.querySelectorAll(".collectionFilterGroupValue, .collectionFilterGroupValueSize").forEach((element) => {
        // remove active class
        element.classList.remove("active");

        const matchingEl = sectionDocument.querySelector(`
            .collectionFilterGroupValue[data-key="${element.getAttribute("data-key")}"], 
            .collectionFilterGroupValueSize[data-key="${element.getAttribute("data-key")}"],
            .collectionFilterGroupValueColor[data-key="${element.getAttribute("data-key")}"]
        `);

        if (!matchingEl) {
            return;
        }

        element.classList.toggle("active", matchingEl.classList.contains("active"));

        // This updates the filters href to either the url to add or remove the filter
        element.setAttribute("href", matchingEl.href);
    });

    // Update filter button count
    const mobileFilterButton = document.querySelector(".collectionGridActionsFilterMobileButtonLabel");
    const activeFilterCount = document.querySelectorAll(".collectionFilterGroupValue.active, .collectionFilterGroupValueSize.active").length;
    activeFilterCount > 0 ? mobileFilterButton.textContent = `Filter (${activeFilterCount})` : mobileFilterButton.textContent = `Filter`;

    // Re-render the active filters
    document.querySelector(".collectionGridActionsActiveFilters")?.remove();
    document.querySelector(".collectionFilterActiveItems")?.remove();

    // Add handleFilterLink listener to active filter items, effectively handling the removal of them
    sectionDocument.querySelectorAll(".collectionGridActionsActiveFiltersItem, .collectionFilterActiveItem").forEach((element) => {
        element.addEventListener("click", handleFilterLinkClick);
    });

    // Add handleFilterLink listener to clear all button
    sectionDocument.querySelector(".collectionGridActionsActiveFiltersClearAllButton").addEventListener("click", handleFilterLinkClick);

    // Append the active filters
    document.querySelector(".collectionGridActions").prepend(sectionDocument.querySelector(".collectionGridActionsActiveFilters"));
    document.querySelector(".collectionFilterActive").appendChild(sectionDocument.querySelector(".collectionFilterActiveItems"));

    // Reset collection items HTML
    document.querySelector(".collectionGridItems").innerHTML = "";

    // Append all collection items and attach listeners
    sectionDocument.querySelectorAll(".collectionItem").forEach((el) => {
        // Quick Add Desktop
        el.querySelectorAll(".collectionItemImageQuickAddSize").forEach((button) => {
            button.addEventListener("click", handleQuickAdd);
        });

        // Quick Add Mobile
        el.querySelectorAll(".collectionItemQuickAddSize").forEach((button) => {
            button.addEventListener("click", handleQuickAdd);
        });

        // Append it to the grid
        document.querySelector(".collectionGridItems").appendChild(el);
    });

    StampedFn.loadBadges();

    await setupSwatches();

    // Append updated button
    const loadMoreButton = sectionDocument.querySelector(".collectionLoadMoreButton");
    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", handleLoadMoreButtonClick);
        document.querySelector(".collectionGridItems").appendChild(sectionDocument.querySelector(".collectionLoadMoreButton"));
    }

    // Append no more results button if present
    const noMoreResultsButton = sectionDocument.querySelector(".collectionNoMoreResultsButton");
    if (noMoreResultsButton) {
        document.querySelector(".collectionGridItems").appendChild(noMoreResultsButton);
    }
}

// Add handleFilterLinkClick to all filter links
document.querySelectorAll(".collectionFilterGroupValue, .collectionFilterGroupValueSize, .collectionGridActionsActiveFiltersItem, .collectionGridActionsActiveFiltersClearAllButton, .collectionFilterActiveItem").forEach(element => {
    element.addEventListener("click", handleFilterLinkClick);
});

// setup dropdowns
document.querySelectorAll(".collectionFilterGroupTitle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// sort select open
document.querySelector(".collectionGridActionsSortSelectLabel").addEventListener("click", function (e) {
    document.querySelector(".collectionGridActionsSortSelect").classList.toggle("open");
});

// sort link click
document.querySelectorAll(".collectionGridActionsSortSelectOptionLink").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector(".collectionGridActionsSortSelect").classList.toggle("open");
    });
});

// Mobile Filter Button
document.querySelector(".collectionGridActionsFilterMobileButton").addEventListener("click", function (e) {
    document.querySelector("#collectionFilter").classList.add("active");
});

// Close Mobile Filter
document.querySelector(".collectionFilterTitleClose").addEventListener("click", function (e) {
    document.querySelector("#collectionFilter").classList.remove("active");
});

/*****************
 * Swatches
 ******************/

// Setup swatches on load
document.addEventListener("DOMContentLoaded", async function () {
    await setupSwatches();
});

/**
 * Setup swatches on all collection items.
 * @return void
 */
async function setupSwatches() {
    const globalColorSwatches = await getGlobalColorSwatches();
    const collectionItems = document.querySelectorAll(".collectionItem");
    const swatchProductHandles = new Set();

    collectionItems.forEach((item) => {
        item.querySelector(".collectionItemSwatchesGrid").innerHTML = "";

        for (let i = 0; i <= 5; i++) {
            item.querySelector(".collectionItemSwatchesGrid").insertAdjacentHTML("afterbegin", `<div class="collectionItemSwatchesGridItemSkeleton"></div>`);
        }

        const swatches = JSON.parse(item.dataset.swatches)
            .map(swatch => `${getBaseProductHandle(item.dataset.handle)}${swatch.replace("swatch:", "")}`);

        // push swatches
        swatches.forEach((handle) => {
            swatchProductHandles.add(handle);
        });
    });

    const productQueries = Array.from(swatchProductHandles).map((swatch, idx) => {
        return `product_${idx}: product(handle: "${swatch}"){
            handle
            onlineStoreUrl
    }`
    });

    // Request swatches from storefront API
    const swatchProductsReq = await client.request(
        `
        query CollectionProducts {
           ${productQueries}
        }
    `
    );

    // Wait for data
    const swatchProducts = await swatchProductsReq.data;

    const availableSwatches = [];

    // Add available swatches to array
    for (const swatchProduct in swatchProducts) {
        if (swatchProducts[swatchProduct]?.onlineStoreUrl && swatchProducts[swatchProduct]?.handle) {
            availableSwatches.push(swatchProducts[swatchProduct].handle);
        }
    }

    // Create swatches
    collectionItems.forEach((item) => {
        const swatches = JSON.parse(item.dataset.swatches)
            .map(swatch => swatch.replace("swatch:", ""))

        const baseHandle = getBaseProductHandle(item.dataset.handle);

        item.querySelector(".collectionItemSwatchesGrid").innerHTML = "";

        // Filter unavailable swatches
        const swatchesForItem = swatches.filter((swatch) => {
            return availableSwatches.includes(`${baseHandle}${swatch}`);
        });

        // Append 5 swatches to item
        swatchesForItem.slice(0, 5).forEach((swatch) => {
            const swatchObj = globalColorSwatches.find(color => color.handle === handleize(`swatch-${swatch}`));

            // Skip if we can't find that swatch data
            if (!swatchObj) {
                return;
            }

            item.querySelector(".collectionItemSwatchesGrid").appendChild(
                createCollectionSwatchItemElement(
                    baseHandle,
                    swatchObj
                )
            );
        });

        const extraSwatches = swatchesForItem.length - item.querySelectorAll(".collectionItemSwatchesGrid .collectionItemSwatchesGridItem").length;

        // Show more swatches message
        if (extraSwatches > 0) {
            item.querySelector(".collectionItemSwatchesGrid").insertAdjacentHTML("beforeend", `
                <a href="/products/${baseHandle}${swatchesForItem[0]}" 
                aria-label="Click to browse ${extraSwatches} more swatches ${baseHandle}"
                >
                    +${extraSwatches}
                </a>
            `)
        }
    });
}

/*
* Create swatch element
* @param {String} baseHandle
* @param {String} swatch
* @returns {HTMLElement}
*/
function createCollectionSwatchItemElement(baseHandle, swatch) {
    if (!swatch) {
        return;
    }

    const swatchHandle = swatch.handle.replace("swatch-", "");
    const swatchEl = document.createElement("a");
    swatchEl.setAttribute("href", `/products/${baseHandle}${swatchHandle}`);
    swatchEl.setAttribute("data-tippy-content", swatch.fields.find(field => field.key === "name").value);
    swatchEl.classList.add("collectionItemSwatchesGridItem");

    const tag = swatch.fields.find(field => field.key === "tag");

    switch (tag.value) {
        case 'img':
            const image = swatch.fields.find(field => field.key === "image");
            swatchEl.style.backgroundImage = `url(${image.thumbnail.file.image.src})`;
            break;
        case 'hex':
            const gradientDirection = swatch.fields.find(field => field.key === "gradient_direction");
            if (gradientDirection.value) {
                swatchEl.style.background = `linear-gradient(${gradientDirection.value})`;
                break;
            }
            const color = swatch.fields.find(field => field.key === "color");
            swatchEl.style.backgroundColor = `${JSON.parse(color.value)[0]}`;
            break;
    }

    tippy(swatchEl);

    return swatchEl;
}

/*****************
 * AJAX Load More
 ******************/

/**
 * Handle a load more button click
 * @param {Event} event
 * @return void
 */
async function handleLoadMoreButtonClick(event) {
    event.preventDefault();

    if (!this.href) {
        return;
    }

    this.classList.add("loading");

    // Build a url
    const url = new URL(this.href);

    url.searchParams.set("sections", "main-collection");

    const section = await fetch(url.toString());

    const sectionJson = await section.json();

    const htmlParser = new DOMParser();

    const sectionDocument = htmlParser.parseFromString(sectionJson["main-collection"], "text/html");

    // Remove load more button
    this.remove();

    // get all collection items
    sectionDocument.querySelectorAll(".collectionItem").forEach((el) => {
        // Attach quick add event listeners
        el.querySelectorAll(".collectionItemImageQuickAddSize").forEach((button) => {
            button.addEventListener("click", handleQuickAdd);
        });

        el.querySelectorAll(".collectionItemQuickAddSize").forEach((button) => {
            button.addEventListener("click", handleQuickAdd);
        });

        // Append it to the grid
        document.querySelector(".collectionGridItems").appendChild(el);
    });

    StampedFn.loadBadges();

    await setupSwatches();

    // Add event listeners to new load more button
    const loadMoreButton = sectionDocument.querySelector(".collectionLoadMoreButton");

    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", handleLoadMoreButtonClick);

        // Append load more button
        document.querySelector(".collectionGridItems").appendChild(sectionDocument.querySelector(".collectionLoadMoreButton"));
    }

    // Append no more results button if present
    const noMoreResultsButton = sectionDocument.querySelector(".collectionNoMoreResultsButton");
    if (noMoreResultsButton) {
        document.querySelector(".collectionGridItems").appendChild(noMoreResultsButton);
    }

}

// Attach handleLoadMore to the load more button
document.querySelector(".collectionLoadMoreButton")?.addEventListener("click", handleLoadMoreButtonClick)

// klaviyo tracking
try {
    klaviyo.push(['track', 'Category View', {
        "CategoryName": location.pathname
    }]);
} catch (e) {
    // skip
}